<script setup lang="ts">
import { useMinerDetails } from '@/composables/rc/miner-details'
import { toRefs, computed } from 'vue'
import DiagnosticsResultSection from './DiagnosticsResultSection.vue'
const props = defineProps<{ minerId: number }>()
const { minerId } = toRefs(props)

const { minerDetailsQuery } = useMinerDetails(minerId)
const { data: minerDetails } = minerDetailsQuery

// Server state bindings
const isDiagnosed = computed(() => !!minerDetails.value?.condition.diagnosed)
</script>

<template>
  <RepairSection title="Diagnostic" :step="2" :active="isDiagnosed">
    <div class="w-full flex flex-col gap-2">
      <!-- Part diagnostics buttons section -->
      <DiagnosticsPartsSection :miner-id="minerId" />
      <el-divider />
      <!-- Part diagnostics result section -->
      <DiagnosticsResultSection :miner-id="minerId" />
    </div>
  </RepairSection>
</template>

<style lang="scss" scoped>
.el-popper.is-customized {
  padding: 6px 12px;
  max-width: 30em;
  background: var(--fill-tertiary);

  .el-popper__arrow::before {
    background: var(--fill-tertiary);
  }
}

.diagnostics-table {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 3fr 2fr 2fr;
  align-items: center;
  row-gap: var(--spacing-spacing-md);

  > .el-button {
    height: 32px;
  }
}
</style>
